import { render, staticRenderFns } from "./SAASTree2.vue?vue&type=template&id=44d2ed85"
import script from "./SAASTree2.vue?vue&type=script&lang=js"
export * from "./SAASTree2.vue?vue&type=script&lang=js"
import style0 from "./SAASTree2.vue?vue&type=style&index=0&id=44d2ed85&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports